module.exports = {"name":"clappr","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-04-24","repo":"https://bitbucket.org/npaw/clappr-adapter-js","libVersion":"6.2.2","features":{"buffer":"monitor","seek":"monitor","getters":["getPlayhead","getDuration","getBitrate","getRendition","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 29
// module chunks = 0